import React from 'react';
import { useAuth } from '../../App';
import { Sparkles } from 'lucide-react';
import { FoundingSavingsWidget } from './FoundingSavingsWidget';

/**
 * Founding Provider badge card.
 *
 * Renders on the provider dashboard when beta mode is active and the
 * provider is approved. Tells early adopters they&rsquo;re helping shape
 * the platform. Hides automatically when beta mode turns off.
 */
export default function FoundingProviderBadge({ providerStatus }) {
  const { betaConfig } = useAuth();
  if (!betaConfig?.beta_mode) return null;
  if (providerStatus !== 'approved') return null;

  return (
    <div
      className="mb-4 rounded-lg border border-[#D4AF37]/40 bg-gradient-to-r from-amber-50 via-white to-amber-50/60 p-4 flex items-start gap-3"
      data-testid="founding-provider-badge"
    >
      <div className="shrink-0 w-10 h-10 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center">
        <Sparkles className="h-5 w-5 text-[#D4AF37]" />
      </div>
      <div className="min-w-0">
        <p className="text-sm font-medium text-[#1A1A1A]">
          You&rsquo;re a Founding Provider
        </p>
        <p className="text-xs text-stone-600 mt-0.5">
          Thank you for joining Zuriya during our beta phase. You get every
          Pro feature at no cost. On new marketplace clients a single{' '}
          {betaConfig.provider_fee_percent}% fee comes off your payout with
          Stripe costs included, and repeat clients or bookings through your
          own link carry no platform fee (Stripe processing still applies).
          Clients never pay a booking fee. Your
          feedback will help shape the future of the platform.
        </p>
        <FoundingSavingsWidget />
      </div>
    </div>
  );
}
